$(function(){
  var lastScrollTop = 0, delta = 15;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();

    if(Math.abs(lastScrollTop - st) <= delta)
      return;
    if ((st > lastScrollTop) && (lastScrollTop>0)) {
      $(".site-i-header").addClass("header-top");

    } else {
      $(".site-i-header").removeClass("header-top");
    }
    lastScrollTop = st;
   //$('body').removeClass('valid');
  });
});

$(document).on("click",".nav-icon-wrap", function(){
  $('body').toggleClass('nav-drawer-opened');
});

$('.nav-drawer-close, .nav-drawer-mask').on('click', function(){
  $('body').removeClass('nav-drawer-opened');
});

if($(window).width() <= 991){
  $(document).on('click', '.f-links-grid > h5', function(){
    $(this).toggleClass('active').parents('.f-links-grid').siblings('.f-links-grid').find('h5').removeClass('active');
    $(this).next('ul').slideToggle().parents('.f-links-grid').siblings('.f-links-grid').find('ul').slideUp();
  });
  
  /* blog page */
  $(document).on('click', '.blog-i-bar > h6', function(){
    $(this).toggleClass('active').parents('.blog-i-bar').siblings('.blog-i-bar').find('h6').removeClass('active');
    $(this).next('.toggle-blog-bar').slideToggle().parents('.blog-i-bar').siblings('.blog-i-bar').find('.toggle-blog-bar').slideUp();
  });
}

$(document).ready(function(){
  function fadeInPage() {
    if (!window.AnimationEvent) { return; }
    $('#fader').addClass('fade-out');

    setTimeout(function() {
      $('body').addClass('headerShow');
    }, 500);
  }
  fadeInPage();

  $('.coll_slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 200,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false
  });
  
  if($('.pr-i-sldier li').length > 2){
    $('.product-slider .pr-i-sldier').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }       
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }       
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }       
        }
      ]
    });
  }
  
  /* mega menu slider */
  if($('.mega-menu-slider li').length > 5){
    $('.mega-menu-wrap .mega-menu-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }       
        }
      ]
    });
  }

  /* blog page */
  if($('.video-slide li').length > 1){
    $('.video-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
  }
  
  $('.cmn-blogs .blog-grids').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1651,
        settings: {
          slidesToShow: 3
        }       
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2
        }          
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }          
      }
    ]
  });
    
  if($('.cmn-blogs .blog-grids li').length <= 3 && $(window).width() >= 992) {
    $('.cmn-blogs .blog-grids').slick('unslick');
  }
  
  /* collection page */
  $('.coll-grids ul li').mouseenter(function () {
    $(this).addClass('active-coll').siblings('li').removeClass('active-coll');
  });
  
  /* product page */
  $(document).on('click', '.prod-collps-disc ul li h6', function(){
    $(this).toggleClass('active').parents('li').siblings('li').find('h6').removeClass('active');
    $(this).next('.collps-disc').slideToggle().parents('li').siblings('li').find('.collps-disc').slideUp();
  });
  
  /* theme parallax effect */
  const can = document.querySelectorAll(".can > img");
  const randomX = random(10, 10);
  const randomY = random(20, 20);
  const randomDelay = random(0, 1);
  const randomTime = random(3, 15);
  const randomTime2 = random(5, 20);
  const randomAngle = random(8, 12);

  TweenLite.set(can, {
    x: randomX(-1),
    y: randomX(1),
    rotation: randomAngle(-1)
  });

  moveX(can, 1);
  moveY(can, -1);
  rotate(can, 1);

  function rotate(target, direction) {
    TweenLite.to(target, randomTime2(), {
      rotation: randomAngle(direction),
      // delay: randomDelay(),
      ease: Sine.easeInOut,
      onComplete: rotate,
      onCompleteParams: [target, direction * -1]
    });
  }

  function moveX(target, direction) {
    TweenLite.to(target, randomTime(), {
      x: randomX(direction),
      ease: Sine.easeInOut,
      onComplete: moveX,
      onCompleteParams: [target, direction * -1]
    });
  }

  function moveY(target, direction) {
    TweenLite.to(target, randomTime(), {
      y: randomY(direction),
      ease: Sine.easeInOut,
      onComplete: moveY,
      onCompleteParams: [target, direction * -1]
    });
  }

  function random(min, max) {
    const delta = max - min;
    return (direction = 1) => (min + delta * Math.random()) * direction;
  }
});

$(document).ready(function(){
  
  // Newsletter validation //   
  $(".newsltrbtn").click(function(){
    var form = $(this).parents("form");
    var email = form.find(".email").val();
    var filter = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    
    if(email == ''){
      form.find(".newsletter_error").text("Email field can't blank").show();
      form.find(".email").focus();
      return false;
    }
    else if(!filter.test(email)) {
      form.find(".newsletter_error").text("Invalid Email").show();
      form.find(".email").focus();
      return false;
    }
    else{
      form.find(".newsletter_error").text("").hide();
      return true;
    }
  });
  
  // Contact Validation // 
  $(".contact_submit").click(function(){
    var form = $(this).parents("form");
    var first_name = form.find(".first_name").val();
    var last_name = form.find(".last_name").val();
    var email = form.find(".email").val();
    var filter = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var phone = form.find(".phone").val();
    var sel_option = form.find(".sel_option").val();
    var message = form.find(".message").val();
    
    if(first_name == ''){
      form.find(".contact_error").text("First Name field can't blank").show();
      form.find(".first_name").focus();
      return false;
    }
    else if(last_name == ''){
      form.find(".contact_error").text("Last Name field can't blank").show();
      form.find(".last_name").focus();
      return false;
    }
    else if(email == ''){
      form.find(".contact_error").text("Email field can't blank").show();
      form.find(".email").focus();
      return false;
    }
    else if(!filter.test(email)) {
      form.find(".contact_error").text("Invalid Email").show();
      form.find(".email").focus();
      return false;
    }
    else if(phone == '') {
      form.find(".contact_error").text("Phone Number field can't blank").show();
      form.find(".phone").focus();
      return false;
    }
    else if(sel_option == '') {
      form.find(".contact_error").text("Select any Option").show();
      form.find(".sel_option").focus();
      return false;
    }
    else if(message == '') {
      form.find(".contact_error").text("Message field can't blank").show();
      form.find(".message").focus();
      return false;
    }
    else{
      form.find(".contact_error").text("").hide();
      return true;
    }
  });
  
  // Login validation //   
  $(".login_btn").click(function(){
    var form = $(this).parents("form");
    var email = form.find(".email").val();
    var filter = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var password = form.find(".password").val();
    
    if(email == ''){
      form.find(".login_error").text("Email field can't blank").show();
      form.find(".email").focus();
      return false;
    }
    else if(!filter.test(email)) {
      form.find(".login_error").text("Invalid Email").show();
      form.find(".email").focus();
      return false;
    }
    else if(password == ''){
      form.find(".login_error").text("Password field can't blank").show();
      form.find(".password").focus();
      return false;
    }
    else{
      form.find(".login_error").text("").hide();
      return true;
    }
  });
  
  
  // forget password validation //   
  $(".forget_btn").click(function(){
    var form = $(this).parents("form");
    var email = form.find(".email").val();
    var filter = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    
    if(email == ''){
      form.find(".forget_error").text("Email field can't blank").show();
      form.find(".email").focus();
      return false;
    }
    else if(!filter.test(email)) {
      form.find(".forget_error").text("Invalid Email").show();
      form.find(".email").focus();
      return false;
    }
    else{
      form.find(".forget_error").text("").hide();
      return true;
    }
  });
  
  // register Validation // 
  $(".register_btn").click(function(){
    var form = $(this).parents("form");
    var first_name = form.find(".first_name").val();
    var last_name = form.find(".last_name").val();
    var email = form.find(".email").val();
    var filter = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var password = form.find(".create_password").val();
    
    if(first_name == ''){
      form.find(".register_error").text("First Name field can't blank").show();
      form.find(".first_name").focus();
      return false;
    }
    else if(last_name == ''){
      form.find(".register_error").text("Last Name field can't blank").show();
      form.find(".last_name").focus();
      return false;
    }
    else if(email == ''){
      form.find(".register_error").text("Email field can't blank").show();
      form.find(".email").focus();
      return false;
    }
    else if(!filter.test(email)) {
      form.find(".register_error").text("Invalid Email").show();
      form.find(".email").focus();
      return false;
    }
    else if(password == '') {
      form.find(".register_error").text("Password field can't blank").show();
      form.find(".create_password").focus();
      return false;
    }
    else{
      form.find(".register_error").text("").hide();
      return true;
    }
  });
  
  // active account validation //   
  $(".active_account_btn").click(function(){
    var form = $(this).parents("form");
    var password = form.find(".password").val();
    var confirm_password = form.find(".confirm_password").val();

    if(password == ''){
      form.find(".activate_error").text("Password field can't blank").show();
      form.find(".password").focus();
      return false;
    }
    else if(confirm_password == ''){
      form.find(".activate_error").text("Confirm Password field can't blank").show();
      form.find(".confirm_password").focus();
      return false;
    }
    else if(password != confirm_password) {
      form.find(".activate_error").text("Password not match").show();
      form.find(".confirm_password").val('');
      form.find(".confirm_password").focus();
      return false;
    }
    else{
      form.find(".activate_error").text("").hide();
      return true;
    }
  });
  
   // active account validation //   
  $(".active_account_btn").click(function(){
    var form = $(this).parents("form");
    var password = form.find(".password").val();
    var confirm_password = form.find(".confirm_password").val();

    if(password == ''){
      form.find(".activate_error").text("Password field can't blank").show();
      form.find(".password").focus();
      return false;
    }
    else if(confirm_password == ''){
      form.find(".activate_error").text("Confirm Password field can't blank").show();
      form.find(".confirm_password").focus();
      return false;
    }
    else if(password != confirm_password) {
      form.find(".activate_error").text("Password not match").show();
      form.find(".confirm_password").val('');
      form.find(".confirm_password").focus();
      return false;
    }
    else{
      form.find(".activate_error").text("").hide();
      return true;
    }
  });
  
    // Reset Password validation //   
  $(".btn_reset_passord").click(function(){
    var form = $(this).parents("form");
    var password = form.find(".password").val();
    var confirm_password = form.find(".confirm_password").val();

    if(password == ''){
      form.find(".reset_error").text("Password field can't blank").show();
      form.find(".password").focus();
      return false;
    }
    else if(confirm_password == ''){
      form.find(".reset_error").text("Confirm Password field can't blank").show();
      form.find(".confirm_password").focus();
      return false;
    }
    else if(password != confirm_password) {
      form.find(".reset_error").text("Password not match").show();
      form.find(".confirm_password").val('');
      form.find(".confirm_password").focus();
      return false;
    }
    else{
      form.find(".reset_error").text("").hide();
      return true;
    }
  });
});

window.prevX = 0;
window.prevY = 0;
window.mouseXPos = 0;
window.mouseYPos = 0;
$(document).ready(initialBubbles);

$(document).on('touchmove',function(e){
  e.preventDefault();
  var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
  window.mouseXPos = touch.pageX;
  window.mouseYPos = touch.pageY;
});

setInterval(function(){
  if(window.prevX == window.mouseXPos && window.prevY == window.mouseYPos){ return;}
  window.prevX = window.mouseXPos;
  window.prevY = window.mouseYPos; makeBubble(); 
},200);  

//from Stackoverflow
//https://stackoverflow.com/questions/1484506/random-color-generator
function randomHsl() {
  return 'hsla(' + (Math.random() * 360) + ', 100%, 50%, 1)';
}

function initialBubbles(){
  var i=0;
  var initTimer = setInterval(function(){
    i++;
    
    makeBubble({
      top: window.innerHeight + 'px',
      left: Math.floor(Math.random()*(window.innerWidth-10+1)+10)
    });
    
    if (i==50){
      clearInterval(initTimer);
      backgroundBubbles();
    }
  },300);
}

function backgroundBubbles(){
  var backgroundTimer = setInterval(function(){
    makeBubble({
      top: window.innerHeight + 'px',
      left: Math.floor(Math.random()*(window.innerWidth-10+1)+10)
    });
  },500);
}

function makeBubble(options,isBackground){
  isBackground = isBackground || false;
  options = options || {};
  options = {
    top: options.top || window.mouseYPos + "px",
    left: options.left || window.mouseXPos + "px"
  };
  var dm = Math.floor(Math.random()*(200-50+1)+50);
  var el = $('<div class="bubble '+ (isBackground ? 'background':'') + '"></div>');
  $('body').append(el.removeClass('ref').css({'top': options.top, 'left': options.left ,'background-color':randomHsl(),'height':(dm - (dm/2)) + 'px','width':(dm - (dm/2)) + 'px'}).animate({top:'-100px'},1500,function(){ $(this).remove(); }));
}

if($(window).width() <= 1024){
  $('input.autofocus, select, textarea').on('blur', function(){
    $('body').removeClass('valid');
  });
  $('input.autofocus, select, textarea').on('focus', function(){
    $('body').addClass('valid');
  });
  $('input.autofocus, select, textarea').on('change', function() {
    $('body').removeClass('valid');
  });
}

// 22-12-2021
$(document).ready(function(){
  $('.nav-icon-wrap').click(function(){
    $(this).toggleClass('open closed');
  });

  if($(window).width() > 767){
     $(".site-i-header nav>ul>li img").hover(function () {
       $(this).toggleClass("hover");
       $(this).siblings().toggleClass("not-hover");
     });
  }
  else{
    console.log("fds");
    $(".sub-i-header nav>ul>li> img").click(function(){
      $(this).siblings(".mega-menu-wrap").toggleClass("menu-active");
      $(this).parent("li").siblings().find(".mega-menu-wrap").removeClass("menu-active");
      $(this).parent("li").siblings().find(".down_arrow").removeClass('down_arrow');
      $(this).toggleClass("down_arrow");
    });
  }
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 300,
    asNavFor: '.slider-nav',
     responsive: [
    {
      breakpoint: 576,
      settings: {
        arrows: false,
         
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
  
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    infinite: true,
    speed: 300,
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding:'0',
         
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });

  $(document).on("click",".qty-plus",function(){
    var curr_qty = $(this).parents('.pr-add-qty').find("input[name='quantity']").val();
    $(this).parents('.pr-add-qty').find("input[name='quantity']").val(parseInt(curr_qty)+1);
  });
  
  $(document).on("click",".qty-minus",function(){
    var curr_qty = $(this).parents('.pr-add-qty').find("input[name='quantity']").val();
    if(curr_qty != 1) {
      $(this).parents('.pr-add-qty').find("input[name='quantity']").val(parseInt(curr_qty)-1);
    }
  });

  $(document).on("click",".buy-now-btn",function(){
    $(".shopify-payment-button__button").trigger("click");
  });

  /* mini cart */
  $(document).on("click", ".right-user .cart__Icon", function() {
    $(".mini-cart-page").addClass("mini-cart-active");
    $("html body").addClass("overflow-hidden");
  });
  
  $(document).on("click",".mini-cart-page", function(event){
    if($(event.target).hasClass("mini-cart-page") || $(event.target).hasClass("close-icon")) {
      $(".mini-cart-active").removeClass("mini-cart-active");
      $("html body").removeClass("overflow-hidden");
    }
  });

  $(document).on("click",".close-btn .close-icon", function(event){
      $(".mini-cart-active").removeClass("mini-cart-active");
      $("html body").removeClass("overflow-hidden");
  });
  
  $(document).on("click",".addToCart",function(){
    var form = $(this).parents("form");
    var form_data = form.serialize();
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form_data,
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cartdata){
            
            var cart_item = $(cartdata).find(".mini-cart-wrap").html();
            $('.mini-cart-wrap').html(cart_item);

            var cart_count = $(cartdata).find(".cart__Icon .cart-badge").text();
            $(".cart__Icon .cart-badge").text(cart_count);

            $(".cart__Icon").trigger("click");
          }
        });
      }
    });
     
  });

  $(document).on("click",".add-pro-btn",function(){
    var vid = $(this).parents(".best-selling-pro").find(".vari_id").val();
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:vid,quantity:1},
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cartdata){
            var cart_item = $(cartdata).find(".mini-cart-wrap").html();
            $('.mini-cart-wrap').html(cart_item);

            var cart_count = $(cartdata).find(".cart__Icon .cart-badge").text();
            $(".cart__Icon .cart-badge").text(cart_count);
          }
        });
      }
    });
     
  });

  $(document).on('click','.cart-form .qty-minus, .cart-form .qty-plus', function(){
    console.log("fdsfss");
    var curr_val = $(this).parents('.cart-plus-minus').find('.qty_val').val();
    var curr_id = $(this).parents('.cart-plus-minus').find('.qty_val').attr('data-id');

    if($(this).attr('data') == 'minus') {
      if(curr_val != 0) {
        curr_val--;
      }
    }else {
      curr_val++;
    }
    cart_update(curr_id, curr_val);
  });
  
  $(document).on('click','.cart-form .remove-item', function(){
    console.log("remove");
    var curr_id = $(this).attr("data-id");
    cart_update(curr_id, 0);

    $(this).addClass('cart-remove-loader');
    setTimeout(function() {
      //$element.removeClass("cart_loader"); // Remove the "cart_loader" class after a delay of 2000 milliseconds (2 seconds)
      $(".remove-item").removeClass('cart-remove-loader');
    }, 5000);
    
  });
   $(document).on('click','.add-btn-wrap .add-pro-btn', function(){
    console.log("remove");
    var curr_id = $(this).attr("data-id");
    cart_update(curr_id, 0);

    $(this).addClass('cart-addd-loader');
    setTimeout(function() {
      //$element.removeClass("cart_loader"); // Remove the "cart_loader" class after a delay of 2000 milliseconds (2 seconds)
      $(".add-pro-btn").removeClass('cart-addd-loader');
    }, 5000);
    
  });

  function cart_update(id, qty) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {id:id,quantity:qty},
      dataType: 'json',
      success: function(cart_data){
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cartdata){
            var cart_item = $(cartdata).find(".mini-cart-wrap").html();
            $('.mini-cart-wrap').html(cart_item);

            var cart_count = $(cartdata).find(".cart__Icon .cart-badge").text();
            $(".cart__Icon .cart-badge").text(cart_count);
          }
        });
      }
    });
  }

  $(document).ready(function(){
      if(window.innerWidth > 650){
        $('.slide-img').zoom({
         magnify:1
        });
      }
  });
  (function(e){var z={url:!1,callback:!1,target:!1,duration:120,on:"click",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};e.zoom=function(d,o,n,v){var s,u,r,a,c,m,h,i=e(d),l=i.css("position"),f=e(o);return d.style.position=/(absolute|fixed)/.test(l)?l:"relative",d.style.overflow="hidden",n.style.width=n.style.height="",e(n).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:n.width*v,height:n.height*v,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(d),{init:function(){u=i.outerWidth(),s=i.outerHeight(),o===d?(a=u,r=s):(a=f.outerWidth(),r=f.outerHeight()),c=(n.width-u)/a,m=(n.height-s)/r,h=f.offset()},move:function(t){var p=t.pageX-h.left,g=t.pageY-h.top;g=Math.max(Math.min(g,r),0),p=Math.max(Math.min(p,a),0),n.style.left=p*-c+"px",n.style.top=g*-m+"px"}}},e.fn.zoom=function(d){return this.each(function(){var o=e.extend({},z,d||{}),n=o.target&&e(o.target)[0]||this,v=this,s=e(v),u=document.createElement("img"),r=e(u),a="mousemove.zoom",c=!1,m=!1;if(!o.url){var h=v.querySelector("img");if(h&&(o.url=h.getAttribute("data-src")||h.currentSrc||h.src),!o.url)return}s.one("zoom.destroy",function(i,l){s.off(".zoom"),n.style.position=i,n.style.overflow=l,u.onload=null,r.remove()}.bind(this,n.style.position,n.style.overflow)),u.onload=function(){var i=e.zoom(n,v,u,o.magnify);function l(t){i.init(),i.move(t),r.stop().fadeTo(e.support.opacity?o.duration:0,1,e.isFunction(o.onZoomIn)?o.onZoomIn.call(u):!1)}function f(){r.stop().fadeTo(o.duration,0,e.isFunction(o.onZoomOut)?o.onZoomOut.call(u):!1)}o.on==="grab"?s.on("mousedown.zoom",function(t){t.which===1&&(e(document).one("mouseup.zoom",function(){f(),e(document).off(a,i.move)}),l(t),e(document).on(a,i.move),t.preventDefault())}):o.on==="click"?s.on("click.zoom",function(t){if(!c)return c=!0,l(t),e(document).on(a,i.move),e(document).one("click.zoom",function(){f(),c=!1,e(document).off(a,i.move)}),!1}):o.on==="toggle"?s.on("click.zoom",function(t){c?f():l(t),c=!c}):o.on==="mouseover"&&(i.init(),s.on("mouseenter.zoom",l).on("mouseleave.zoom",f).on(a,i.move)),o.touch&&s.on("touchstart.zoom",function(t){t.preventDefault(),m?(m=!1,f()):(m=!0,l(t.originalEvent.touches[0]||t.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(t){t.preventDefault(),i.move(t.originalEvent.touches[0]||t.originalEvent.changedTouches[0])}).on("touchend.zoom",function(t){t.preventDefault(),m&&(m=!1,f())}),e.isFunction(o.callback)&&o.callback.call(u)},u.setAttribute("role","presentation"),u.alt="",u.src=o.url})},e.fn.zoom.defaults=z})(window.jQuery);

  
});


